'use strict';

/**
 * Model for a share item
 *
 * @category   Model
 * @module     share
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Model = require('base/Colido.Model');

var ShareModel = Model.extend({
    api: '/shares',

    idAttribute: 'token',

    localAttributes: ['catalog'],

    defaults: function() {
        return {
            url: '',
            type: '', //set, location, object
            typeId: null, //[int] setId, locationId, objectId
            title: '', //set name, location name, object name
            fullname: '',
            imageUrl: '',
            activeDetailFields: [],
        }
    },

    getCaption: function(count) {
        var fullname = this.get('fullname');

        return count + ' ' + App.t('collection::objects:count', count) + (fullname ? ' ' + App.t('share::subheadline:attribution', {name: fullname}) : '');
    },

    getImageUrl: function(size) {
        size = size || '1200x1200';

        var image = this.get('image');
        if (image) {
            return 'http:' + image.baseUrl + size + '/' + image.fileName;
        }

        return ''; //@todo return placeholder image
    },

    getAvailableDetailFields: function() {
        var catalog = this.get('catalog');

        var detailFields = [];
        var detailFieldsSections = catalog.getDetailFields({isShowroom: true});
        _.each(detailFieldsSections, function(section) {
            _.each(section, function(field){
                detailFields.push(field);
            }.bind(this));
        }.bind(this));

        return detailFields;
    },

    getDetailFields: function() {
        var shareFields = [];
        var activeDetailFields = this.get('activeDetailFields');
        var detailFields = this.getAvailableDetailFields();

        _.each(detailFields, function(field){
            field.active = _.contains(activeDetailFields, field.name);

            shareFields.push(field);
        }.bind(this));

        return shareFields;
    },

});

module.exports = ShareModel;